module.exports = __webpack_public_path__ + "static/media/gr.b41b5f52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gr.svg
// module id = 134
// module chunks = 0